module.exports = __webpack_public_path__ + "media/images/Group 13416-ec47d7f7d8a63c0ab44803496e56733d.svg";